// extracted by mini-css-extract-plugin
export default {"misc-btn":"misc-btn","primary":"primary","default":"default"};